export const SITE_DOMAIN = 'inducelabs.ai';
export const SITE_URL = `https://${SITE_DOMAIN}`;
export const STUDIO_SIGNUP_URL = `https://studio.${SITE_DOMAIN}`;
// Temporary: assets still served from getinduce CDN.
export const CDN_BASE_URL = 'https://distribution.getinduce.com/assets/landing_page/';
// export const CDN_BASE_URL = `https://distribution.${SITE_DOMAIN}/assets/landing_page/`;
export const WAITLIST_API_URL = `https://screenplay-backend.${SITE_DOMAIN}/public/waitlist/beta`;
/** Single inbox until team mailboxes are provisioned. */
export const CONTACT_EMAIL = 'kmb@inducelabs.ai';

// Future team addresses (enable when mailboxes exist):
// export const INFO_EMAIL = `info@${SITE_DOMAIN}`;
// export const SUPPORT_EMAIL = `support@${SITE_DOMAIN}`;
// export const PRIVACY_EMAIL = `privacy@${SITE_DOMAIN}`;
// export const LEGAL_EMAIL = `legal@${SITE_DOMAIN}`;
// export const BILLING_EMAIL = `billing@${SITE_DOMAIN}`;
// India entity (terms-of-service-india.txt): support@, privacy@, legal@, grievance@changexresearch.com

/** Hero / navbar "Talk to Sales" button (Calendly). */
export const FOUNDERS_CALENDLY_URL = 'https://calendly.com/kmb-induceai/30min';

export const Z_INDEX = {
  footer: 1,
  modal: 200,
} as const;

/** Public catalog remains hosted on getinduce until the backend domain migrates. */
export const PRICING_API_URL = 'https://screenplay-backend.getinduce.com/billing/public/pricing';
